var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnits = function SvgUnits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M3.25 2.75h6.417v6.417H3.25zm10.084 0h6.417v6.417h-6.417zm0 10.083h6.417v6.417h-6.417zm-10.084 0h6.417v6.417H3.25z"
  })));
};
export { SvgUnits as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMyAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy4yNSAyLjc1aDYuNDE3djYuNDE3SDMuMjVWMi43NVpNMTMuMzM0IDIuNzVoNi40MTd2Ni40MTdoLTYuNDE3VjIuNzVaTTEzLjMzNCAxMi44MzNoNi40MTd2Ni40MTdoLTYuNDE3di02LjQxN1pNMy4yNSAxMi44MzNoNi40MTd2Ni40MTdIMy4yNXYtNi40MTdaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";